export default __webpack_public_path__ + "static/media/heart.d376eb65.svg";